import React from 'react';
import { displayDate, suitableTime } from '../../../utils/suitableDate';
import caisse from '../../../assets/pictures/caisse.png';
import arrow from '../../../assets/pictures/arrow.png';
import { getSendToPOSDate, getSplashStatus } from '../OrderModal.service';
import moment from 'moment';
import './arrow.css'

interface POSStatusCardProps {
    classes: any;
}
interface ScheduledOrderMessageProps {
    order: any;
    classes: any;
    isFirstPhase?: boolean;
}
export const POSStatusCard: React.FC<POSStatusCardProps> = ({ classes }) => {
    return (
        <div style={classes.caisseContainer}>
            <strong className='pb-3'>
                Envoi de la commande vers le logiciel de caisse
            </strong>
            <img src={arrow} className='arrow' alt='Flèche envoi' />
            <img
                src={caisse}
                className='pt-2'
                style={classes.caisseLogo}
                alt='Logo caisse'
            />
        </div>
    )
};

export const ScheduledOrderMessage: React.FC<ScheduledOrderMessageProps> = ({
    order,
    classes,
    isFirstPhase,
}) => {
    const splashStatus = getSplashStatus(order);
    const showPlannedMessage = !isFirstPhase && splashStatus?.showMessage;
    const date = moment(order?.date);

    return (
        <>
            {showPlannedMessage ? (
                <div className='d-flex flex-column align-items-center justify-content-center my-4 text-center'>
                    <p>
                        Cette commande est prévue pour{' '}
                        <strong>{`${displayDate(date, false)} ${suitableTime(
                            date,
                        )}`}</strong>
                        .
                        <br />
                        Elle sera envoyée au logiciel de caisse{' '}
                        <strong>{getSendToPOSDate(order)}</strong>.
                    </p>
                </div>
            ) : (
                <div className='d-flex justify-content-center align-items-center my-4'>
                    <POSStatusCard classes={classes} />
                </div>
            )}
        </>
    );
};
